import {
	cibBehance,
	cibCcAmex,
	cibCcMastercard,
	cibCcVisa,
	cibDribbble,
	cibFacebook,
	cibFlickr,
	cibGithub,
	cibGooglePay,
	cibInstagram,
	cibLinkedin,
	cibPaypal,
	cibPinterest,
	cibReddit,
	cibSkype,
	cibStackoverflow,
	cibStripe,
	cibTumblr,
	cibTwitter,
	cibVimeo,
	cibVk,
	cibWhatsapp,
	cibXing,
	cibYahoo,
	cibYoutube,
	cifBr,
	cifEs,
	cifFr,
	cifIn,
	cifPl,
	cifUs,
	cilAccountLogout,
	cilAlignCenter,
	cilAlignLeft,
	cilAlignRight,
	cilApplicationsSettings,
	cilArrowLeft,
	cilArrowRight,
	cilArrowTop,
	cilAsterisk,
	cilBan,
	cilBasket,
	cilBell,
	cilBold,
	cilBookmark,
	cilBurger,
	cilCalculator,
	cilCalendar,
	cilCamera,
	cilChartPie,
	cilCheck,
	cilCheckCircle,
	cilChevronBottom,
	cilChevronLeft,
	cilChevronRight,
	cilChevronTop,
	cilCircle,
	cilCloudDownload,
	cilCode,
	cilCommentSquare,
	cilCopy,
	cilCreditCard,
	cilCursor,
	cilCursorMove,
	cilDollar,
	cilDrop,
	cilEnvelopeClosed,
	cilEnvelopeLetter,
	cilEnvelopeOpen,
	cilEuro,
	cilFastfood,
	cilFile,
	cilFullscreen,
	cilFullscreenExit,
	cilGlobeAlt,
	cilGraph,
	cilGrid,
	cilHome,
	cilInbox,
	cilIndentDecrease,
	cilIndentIncrease,
	cilInputPower,
	cilItalic,
	cilJustifyCenter,
	cilJustifyLeft,
	cilLaptop,
	cilLayers,
	cilLightbulb,
	cilList,
	cilListNumbered,
	cilListRich,
	cilLocationPin,
	cilLockLocked,
	cilMagnifyingGlass,
	cilMap,
	cilMobile,
	cilMoon,
	cilNotes,
	cilOptions,
	cilPaperclip,
	cilPaperPlane,
	cilPencil,
	cilPeople,
	cilPhone,
	cilPizza,
	cilPrint,
	cilPuzzle,
	cilRestaurant,
	cilSave,
	cilScrubber,
	cilSettings,
	cilShare,
	cilShareAll,
	cilShareBoxed,
	cilShieldAlt,
	cilSpeech,
	cilSpeedometer,
	cilSpreadsheet,
	cilStar,
	cilSun,
	cilTags,
	cilTask,
	cilTrash,
	cilUnderline,
	cilUser,
	cilUserFemale,
	cilUserFollow,
	cilUserUnfollow,
	cilWarning,
	cilX,
	cilXCircle,
} from '@coreui/icons';

export const icons = Object.assign(
	{},
	{},
	{
		cilAlignCenter,
		cilArrowLeft,
		cilAlignLeft,
		cilAlignRight,
		cilApplicationsSettings,
		cilArrowRight,
		cilPizza,
		cilArrowTop,
		cilAsterisk,
		cilCamera,
		cilBan,
		cilBasket,
		cilBell,
		cilBold,
		cilBookmark,
		cilCalculator,
		cilCalendar,
		cilCloudDownload,
		cilChartPie,
		cilCheck,
		cilChevronBottom,
		cilChevronLeft,
		cilChevronRight,
		cilChevronTop,
		cilCircle,
		cilCheckCircle,
		cilCode,
		cilBurger,
		cilFastfood,
		cilCommentSquare,
		cilCreditCard,
		cilCursor,
		cilCursorMove,
		cilDrop,
		cilDollar,
		cilEnvelopeClosed,
		cilEnvelopeLetter,
		cilEnvelopeOpen,
		cilEuro,
		cilGlobeAlt,
		cilGrid,
		cilFile,
		cilFullscreen,
		cilFullscreenExit,
		cilGraph,
		cilHome,
		cilInbox,
		cilIndentDecrease,
		cilIndentIncrease,
		cilInputPower,
		cilItalic,
		cilJustifyCenter,
		cilJustifyLeft,
		cilLaptop,
		cilLayers,
		cilLightbulb,
		cilList,
		cilListNumbered,
		cilListRich,
		cilLocationPin,
		cilLockLocked,
		cilMagnifyingGlass,
		cilMap,
		cilMoon,
		cilNotes,
		cilOptions,
		cilPaperclip,
		cilPaperPlane,
		cilPencil,
		cilPeople,
		cilPhone,
		cilPrint,
		cilPuzzle,
		cilSave,
		cilCopy,
		cilScrubber,
		cilSettings,
		cilShare,
		cilShareAll,
		cilShareBoxed,
		cilShieldAlt,
		cilSpeech,
		cilSpeedometer,
		cilSpreadsheet,
		cilStar,
		cilSun,
		cilTags,
		cilTask,
		cilTrash,
		cilUnderline,
		cilUser,
		cilUserFemale,
		cilUserFollow,
		cilUserUnfollow,
		cilX,
		cilXCircle,
		cilWarning,
		cilRestaurant,
		cilMobile,
		cilAccountLogout,
	},
	{
		cifUs,
		cifBr,
		cifIn,
		cifFr,
		cifEs,
		cifPl,
	},
	{
		cibSkype,
		cibFacebook,
		cibTwitter,
		cibLinkedin,
		cibFlickr,
		cibTumblr,
		cibXing,
		cibGithub,
		cibStackoverflow,
		cibYoutube,
		cibDribbble,
		cibInstagram,
		cibPinterest,
		cibVk,
		cibWhatsapp,
		cibYahoo,
		cibBehance,
		cibReddit,
		cibVimeo,
		cibCcMastercard,
		cibCcVisa,
		cibStripe,
		cibPaypal,
		cibGooglePay,
		cibCcAmex,
	}
);
